import * as React from 'react';

import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { Link } from '../Link';

import * as styles from './NewbuildingFeatures.css';
import { Icon3DTour16, IconBuilding16, IconComment16, IconCalendar16, IconVideo16 } from '@cian/ui-kit';
import { InteractivePlanirovka16 } from '@cian/ui-kit/prev';

interface INewbuildingFeatureProps {
  url: string;
  title: string;
  dataMark?: string;
  type: 'hasProgressOfConstructions' | 'reviews' | 'hasMvk' | 'has3dTour' | 'hasFlatTourBooking' | 'hasVideo';
  onClick?(type: string): void;
}

const assetMap: { [index: string]: React.ReactNode } = {
  hasProgressOfConstructions: <IconBuilding16 color={'white_100'} />,
  reviews: <IconComment16 color={'white_100'} />,
  hasMvk: <InteractivePlanirovka16 color={'white_100'} />,
  has3dTour: <Icon3DTour16 color={'white_100'} />,
  hasFlatTourBooking: <IconCalendar16 color={'white_100'} />,
  hasVideo: <IconVideo16 color={'white_100'} />,
};

export function NewbuildingFeature(props: INewbuildingFeatureProps) {
  const { url, title, type, onClick } = props;
  const icon = assetMap[type];

  const handleClickFeature = React.useCallback(() => {
    if (onClick) {
      onClick(type);
    }
  }, [type, onClick]);

  return (
    <div className={styles['feature-container']} onClick={handleClickFeature} data-testid="newbuilding-feature">
      <TooltipDesktop title={title} placement="bottom">
        <Link target="blank" url={url} linkStyle={styles['feature']}>
          <div className={styles['feature-icon-wrapper']}>{icon}</div>
        </Link>
      </TooltipDesktop>
    </div>
  );
}
